import { CardContent, CardHeader, Stack } from '@mui/material'
import DashboardLayout from '../../../layoutcontainers/DashboardLayout'
import MaterialTypography from '../../../components/MaterialTypography'
import MaterialButton from '../../../components/MaterialButton'
import { Add, FilterAlt } from '@mui/icons-material'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from '../../../context/popup'
import { useLoading } from '../../../components/Loading'
import Table from '../../../components/Table'
import { deleteData, fetchData } from '../../../services'
import { setCurrentPage, setRowsPerPage, setTotalPages } from "./store/index";
import InsurerRegistryFilterDialog from './components/InsurerRegistryFilterDialog.js';

const InsurerRegistryList = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { showSnackbar } = useSnackbar();
    const { setCircleLoading } = useLoading();

    const currentPage = useSelector((state) => state?.apiInsurerApiStore?.currentPage);
    const rowsPerPage = useSelector((state) => state?.apiInsurerApiStore?.rowsPerPage);
    const totalPages = useSelector((state) => state?.apiInsurerApiStore?.totalPages);

    const [insurerRegistryData, setInsurerRegistryData] = useState([]);
    const [isRefresh, setIsRefresh] = useState(false);
    const [search, setSearch] = useState("");
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [filterData, setFilterData] = useState({
        isActive: "",
        gInsurerId: "",
        gProductId: "",
        gLobId: ""
    });

    useEffect(() => {
        fetchInsurerApiList();
    },[isRefresh, currentPage, rowsPerPage, search])

    //List API
    const fetchInsurerApiList = async () => {
        setCircleLoading(true);
        try {
        let url = `/reference/api-engine/insurer-registry?page=${currentPage}&limit=${rowsPerPage}&searchTerm=${search}`;
                              
        //for active and inactive status
        if(filterData.isActive !== "") {
            url += `&isActive=${filterData.isActive}`;
        }
        if(filterData.gProductId !== "") {
            url += `&gProductId=${filterData.gProductId}`;
        }
        const response = await fetchData(url);
        if(response?.success){
            setInsurerRegistryData(response?.data?.insurer_registries);
            dispatch(setTotalPages(response?.data?.page_size));     
        }
        else{
            //throw error
            showSnackbar("Error Fetching Insurer Api List", "error")
        }
        } catch (error) {
            console.error('Error Fetching Insurer Api List:', error);
            showSnackbar(error?.response?.data?.message || "Network Error", "error")
        }
        finally{
            setCircleLoading(false);
        }
    };

    //delete api function
    const handleDelete = async (row) => {
        try {
            const response = await deleteData(`/reference/insurer/body-type/delete`, {ids:[row?.id]});
            setIsRefresh(!isRefresh);
            if(response?.success){
                showSnackbar(response?.message, "success");
            }
            else{
                showSnackbar(response?.message, "error");
            }
        } catch (error) {
            console.error("Error deleting data:", error);
            showSnackbar("Error deleting Insurer Registry data", "error");
        }
    };
     //table mapping
    const insurerRegistryTable = {
        columns: [
            {
            key: "sno",
            label: "S.No.",
            renderCell: (row) => row.sno,
            },
            {
            key: "gInsurerName",
            label: "Insurer Name",
            renderCell: (row) => row.gInsurerName,
            },
            {
            key: "createdAt",
            label: "Created At",
            renderCell: (row) => row.createdAt,
            },
            {
                key: "isActive",
                label: "Status",
                renderCell: (row) => (
                    <span>
                    {row.isActive ? (
                        <span style={{ color: "green", fontWeight: "bold" }}>Active</span>
                    ) : (
                        <span style={{ color: "red", fontWeight: "bold" }}>Inactive</span>
                    )}
                    </span>
                )
            },
        ],
        rows: insurerRegistryData?.map((item, index) => ({
            id: item?.id,
            sno: index + 1,
            gInsurerName: item?.gInsurerName || "",
            createdAt: new Date(item?.createdAt).toLocaleDateString('en-GB'),
            isActive: item?.isActive,
        })),
    };

    const actions = {
        edit: true,
        view: true,
        delete: true,

        onEdit: (row) => {
            navigate(`/api-integration-engine/insurer-registry/insurer-registry-details?pageType=edit&id=${row.id}`);
        },
        onView: (row) => {
            navigate(`/api-integration-engine/insurer-registry/insurer-registry-details?pageType=view&id=${row.id}`);
        },
        onDelete: (row) => handleDelete(row),
    };

    const handlePaginationChange = (page) => {
        dispatch(setCurrentPage(page));
    };

    const handleRowsPerPageChange = (rowsPerPage) => {
        dispatch(setRowsPerPage(rowsPerPage));
        dispatch(setCurrentPage(1));
    };

    const handleSearch = (value) => {
        setSearch(value);
    };

  return (
    <DashboardLayout>
        <CardHeader title={(
            <Stack
            direction={{ xs: "column", sm: "row" }}
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
            >
                <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                        Insurer Registry List
                    </MaterialTypography>
                    <MaterialTypography variant="caption" color="text">
                        List of Insurer Registry.
                    </MaterialTypography>
                </Stack>
                <Stack direction="row" spacing={1}>
                    <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<FilterAlt/>}
                    onClick={(event) => setAnchorEl(event.currentTarget)}
                    >
                    Filter
                    </MaterialButton>
                    <MaterialButton
                        variant="gradient"
                        color="dark"
                        size="small"
                        startIcon={<Add />}
                        onClick={() => navigate('/api-integration-engine/insurer-registry/insurer-registry-details')}
                    >
                        Insurer Registry
                    </MaterialButton>
                </Stack>
            </Stack>
            )} 
        />
        <CardContent>
            <Table
            columns={insurerRegistryTable?.columns}
            data={insurerRegistryTable?.rows}
            actions={actions}
            pagination={{
                totalPages,
                currentPage,
                onPageChange: (page) => handlePaginationChange(page),
                rowsPerPage,
                onRowsPerPageChange: (rowsPerPage) => handleRowsPerPageChange(rowsPerPage),
                rowsPerPageOptions: [5, 10, 15, 20],
            }}
            getRowKey={(row) => row.id}
            className="custom-table"
            noDataLabel="No Insurer Registry found"
            handleSearch={handleSearch}
            />
        </CardContent>
        <InsurerRegistryFilterDialog
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        filterData={filterData}
        setFilterData={setFilterData}
        onApply={() => {
            setAnchorEl(null);   // close popup
            fetchInsurerApiList();  // call API after filter applied
        }}
        />
    </DashboardLayout>
  )
}

export default InsurerRegistryList